import { LocalizedTextMap, LocalizedTextValue } from '@interfaces/service.interface';

// A localized field as it should be sent back. Editors show one translation,
// so an edit replaces only that one and every other language survives the
// save; an untouched field goes back exactly as it was stored.
//
// `shown` is the resolved string the API returned, `translations` its
// `<field>Localizations` map, and `edited` what the editor holds now (null for
// empty).
export function localizedValue(
  shown: string | null,
  translations: LocalizedTextMap | undefined,
  edited: string | null
): LocalizedTextValue | null {
  if ((shown || null) === edited) {
    return translations ?? shown;
  }

  const shownLocale = translations ?
    Object.keys(translations).find((locale) => translations[locale] === shown) :
    undefined;

  // Nothing to preserve: the field held one untranslated value, or nothing.
  if (!translations || !shownLocale) {
    return edited;
  }

  const updated = { ...translations };

  if (edited) {
    updated[shownLocale] = edited;
  } else {
    delete updated[shownLocale];
  }

  return Object.keys(updated).length > 0 ? updated : null;
}
